import {
  CohortsIncludedProductsQueryDocument,
  CohortMembersStatsQueryDocument
} from "@pathwright/graphql-client/src/generated"

export const COHORTS_INCLUDED_PRODUCTS_QUERY =
  CohortsIncludedProductsQueryDocument

export const COHORT_MEMBERS_STATS_QUERY = CohortMembersStatsQueryDocument
